import state from './groupState'
import mutations from './groupMutations'
import getters from './groupGetters'
import actions from './groupActions'

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}